import React from 'react';
import styled from 'styled-components';
import {isNullOrUndefined, labels} from '../../../../util/utils';
import Tooltip from '../../BaseComponentWrappers/MotifTooltip';
import EllipseControl from '../../EllipsesControl/EllipsesControl';

export default function OARTableFooter({trialBalanceAttributeJson}) {
	const currencyType = isNullOrUndefined(trialBalanceAttributeJson?.currencyType)
		? labels.notApplicableAbbreviation
		: trialBalanceAttributeJson.currencyType;
	const currencyCode =
		currencyType === 'Functional' ? `| ${labels.currencyCode}: ${trialBalanceAttributeJson?.currencyCode}` : '';
	const getBusinessUnitList = () => {
		let businessList = [];
		businessList = trialBalanceAttributeJson?.businessUnit?.map((bu, index) => {
			return (
				<section className="BusinessUnitLabel" key={`businessUnit-${index}`}>
					<EllipseControl content={bu} tooltip={bu} noOfLines={1} />
				</section>
			);
		});
		return businessList;
	};
	const getBusinessUnit = () => {
		let businessUnit;
		switch (trialBalanceAttributeJson?.isAllBusinessUnitSelected) {
			case true:
				businessUnit = (
					<Tooltip
						className={`OARFooterTooltip`}
						variant="alt"
						trigger={labels.all}
						allowHover={false}
						placement="right"
					>
						{getBusinessUnitList()}
					</Tooltip>
				);

				break;
			case false:
				businessUnit = (
					<Tooltip
						className="OARFooterTooltip"
						variant="alt"
						trigger={trialBalanceAttributeJson.businessUnit?.length}
						allowHover={false}
						placement="right"
					>
						{getBusinessUnitList()}
					</Tooltip>
				);
				break;
			default:
				businessUnit = <span className="LabelData">{labels.notApplicableAbbreviation}</span>;
		}
		return businessUnit;
	};

	return (
		<StyledOARTableFooter className="StyledOARTableFooter">
			<span className="LabelData">{`${labels.currencyType}: ${currencyType} ${currencyCode} | ${labels.businessUnit}: `}</span>
			{getBusinessUnit()}
		</StyledOARTableFooter>
	);
}

const StyledOARTableFooter = styled.section`
	.LabelData {
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-24);
		color: var(--neutrals-700);
	}
	span :last-child {
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-24);
		color: #747480;
		&:hover {
			cursor: pointer;
			text-decoration: underline;
		}
	}
`;
